import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@workspace/public-utils'

const PrivateRoute = () => {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="spinner mx-auto mb-4"></div>
          <p className="text-gray-600">로딩 중...</p>
        </div>
      </div>
    )
  }

  return user ? <Outlet /> : <Navigate to="/auth/login" replace />
}

export default PrivateRoute